var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { CheckboxChecked, CheckboxUnchecked } from "@epic-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import createStyles from "@material-ui/core/styles/createStyles";
import makeStyles from "@material-ui/core/styles/makeStyles";
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions;
    return createStyles({
        root: {
            display: "flex",
            padding: spacing(0, 4, 0, 2),
        },
        typography: {
            padding: spacing(2),
            // This allows the `noWrap` behavior to work under a flex parent
            width: 0,
            flexGrow: 1,
        },
        icon: {
            margin: "calc(".concat(spacing(4), "px - 0.75rem)"),
            stroke: palette.text.secondary,
            transition: transitions.create(["fill", "stroke", "color"], {
                duration: transitions.duration.shorter,
            }),
            ".Mui-selected > &": {
                stroke: palette.background.default,
                fill: palette.primary.main,
                color: palette.primary.contrastText,
            },
        },
    });
}, { name: "EuiCheckMenuItem" });
export var CheckMenuItem = React.forwardRef(function CheckMenuItem(_a, ref) {
    var _b;
    var selected = _a.selected, children = _a.children, props = __rest(_a, ["selected", "children"]);
    var classNames = useStyles();
    return (React.createElement(MenuItem, __assign({ selected: selected }, props, { classes: __assign(__assign({}, props.classes), { root: clsx(classNames.root, (_b = props.classes) === null || _b === void 0 ? void 0 : _b.root) }), ref: ref }),
        selected ? (React.createElement(CheckboxChecked, { className: classNames.icon })) : (React.createElement(CheckboxUnchecked, { className: classNames.icon })),
        React.createElement(Typography, { className: classNames.typography, noWrap: true }, children)));
});
//# sourceMappingURL=CheckMenuItem.js.map